import {computed} from "vue";
import {Routes} from "@/config/router/routes";
import {useRoute} from "vue-router";
import {useScreenSize} from "@/composables/use-screen-size";

const ROUTES_WITH_HEADER: Routes[] = [Routes.ChatDetail]

export const useHeaderVisibility = () => {

    const router = useRoute()

    const route = useRoute()

    const { IS_MOBILE } = useScreenSize()

    const layout = computed(() => router.meta?.layout)

    const isAuthLayout = computed(() => layout.value === 'auth')

    const isShowHeader = computed(() => ROUTES_WITH_HEADER.includes(route.name as Routes))

    const isShowHeaderTop = computed(() => isShowHeader.value || IS_MOBILE.value)

    return {
        isShowHeader,
        isAuthLayout,
        isShowHeaderTop
    }
}